
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation",
      function () {
        return require("private-next-pages/docs/payment-initiation/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation"])
      });
    }
  